import { Button, Card } from "flowbite-react";
import { TriangleAlert } from "lucide-react";

type SubventionsErrorProps = { onRetry: () => void };

export const SubventionsError = ({ onRetry }: SubventionsErrorProps) => (
  <Card className="shadow-sm">
    <div className="flex flex-col items-center justify-center px-6 py-12">
      <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-lighterror">
        <TriangleAlert size={40} className="text-error-emphasis" />
      </div>
      <p className="mb-2 text-center text-base font-semibold text-foreground">
        Impossible de charger vos subventions
      </p>
      <p className="mb-5 max-w-md text-center text-sm text-gray-500 dark:text-gray-400">
        Une erreur est survenue. Vérifiez votre connexion, puis réessayez.
      </p>
      <Button color="light" onClick={onRetry}>Réessayer</Button>
    </div>
  </Card>
);

SubventionsError.displayName = "SubventionsError";
